import { render, staticRenderFns } from "./ExtinguisherLine.vue?vue&type=template&id=5c88386c&"
import script from "./ExtinguisherLine.vue?vue&type=script&lang=js&"
export * from "./ExtinguisherLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports